<template >
  
  <div class="labFooter">
    <div class="divFooter">
    <div class="aboutFooter" >
      <h1 class="titleAbout">ABOUT US</h1>
      <span class="sizeText"> The Applied Computing Group (TIC-211) is a PAI research group of the Junta de Andalusia (Spain) that user IT & CS tools, methods, frameworks and standards to improve the application issues of R&D projects an developing novel research issues from the experience and application.</span>
    </div>
    <div class="linksFooter" >
      <div class=" menuFooter">
       <h1 class="titleAbout">MENU</h1>
        <a> <router-link class="colorLink" to="/"><p>Home</p></router-link></a>
        <a><router-link class="colorLink" to="/thing-descriptions"><p>Thing Description</p></router-link> </a>
         <a><router-link class="colorLink" to="/scenarios"><p>Scenarios</p></router-link></a>
        <a><router-link class="colorLink" to="/about"><p>About</p></router-link> </a>
      </div>
      <div class="websiteFooter">
        <h1 class="titleAbout">MAIN WEBSITE</h1>
        <a class="colorLink" href="http://acg.ual.es/">http://acg.ual.es/</a>
      </div>
    </div>
    <div class="contactFooter">
      <h1 class="titleAbout">CONTACT US</h1> 
      <p class="sizeContact">Edif. Científico Técnico, CITE-III <br>Universidad de Almería <br>Almería, España<br>04120</p>
      <a class="colorLink" href="mailto:acg.tic211@ual.es">acg.tic211@ual.es</a>
    </div>
  </div>
  </div>

</template>

<script>


export default {
  name: "Footer",
  
};
</script>
<style>
@media screen and (min-width: 600px) {
.divFooter{
  display: grid;
  grid-template-columns: repeat(3, 1fr);
  place-items: center;
  color:  #FFFFFF;
  padding: 0 1vw 0 1vw;
  position:relative;
  bottom: 0;
  left: 0;
  height: 200px;
  margin: auto;
  max-width: 1150px;
}
.appBody {
  margin-bottom: 0 !important;
}
.labFooter{
  width: 100%; 
  background-color: #2E3038;
  position: relative;
  place-items: center;
}
.aboutFooter{
  /*margin-left: 120px;*/
  padding: 0.5rem;
  display: grid;
  text-align: left;
}


.linksFooter{ 
 
  grid-template-rows: repeat(2,1fr);
 /* margin-left: 150px;*/  
  padding: 0.5rem; 
}

.linksFooter > :first-child {
  margin-bottom: 30px;
}

.menuFooter{
 
  height: auto;
  margin-bottom: 0px; 
}

.websiteFooter{  
  height: auto;
  line-height: 15px;
  margin-top: 0px; 
}

.contactFooter{
 padding: 0.5rem; 
  /*margin-right: 120px;*/
}

.titleAbout{
  font-weight: bold;
  font-size: 14px;
}

.colorLink{
  color:#F7F48B  !important;
  font-size: 11px;
  line-height: 4px;
  margin-bottom: 0px; 
}
.sizeText{
  font-size: 11px;
}
.a{
  font-size: 11px;
  
}
.sizeContact{
  font-size: 11px;
}
}

@media screen and (max-width: 600px) {
  .labFooter{
    background-color: #2E3038;
    width: 100%;
  }
  .divFooter{
    background-color: #2E3038;
    display: grid;
    grid-template-columns: 1fr;
    align-items: center; /* Add this line to center the items vertically */
    color:  #FFFFFF;
    font-size: 12px;
    position:relative;
    padding: 1rem;
    margin: auto;
  }
  .divFooter > * { /* Add this block to make the items smaller and center them */
    padding: 0.5rem;
    margin-right: auto;
    margin-bottom: 30px;
    text-align: left;
  }
  .titleAbout{
    text-align: left;
    font-weight: bold;
    font-size: 15px;
  }
  .linksFooter > :first-child {
    margin-bottom: 50px; 
  }
  .colorLink{
    color:#F7F48B  !important;
    line-height: 4px;
    margin-bottom: 0px; 
  }
  .appBody {
    margin-bottom: 0 !important;
  }
}

</style>